import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import { message, Tooltip } from 'antd'
import classNames from 'classnames'
import styles from './index.module.less'

export default (props) => {
  const { className, itemId, onChange } = props

  const onClick = () => {
    message.success('我们将尽快为你减少相关内容的推荐~')
    onChange(itemId)
  }
  return <div className={classNames(styles['card-uninterested'], className)}>
    <Tooltip placement="bottom" title="不感兴趣" overlayClassName={styles['card-uninterested-tooltip']}>
      <div
        className="card-uninterested-tooltip-icon-wrap"
        onClick={(e) => { e && e.stopPropagation(); onClick() }}
      >
        <Icon type="m-buganxingqu" className="card-uninterested-tooltip-icon-wrap-icon" />
      </div>
    </Tooltip>
  </div>
}
